import { CSRF_URL } from './api';

/* In-memory CSRF token, shared by every dashboard's fetch wrapper
   (IcibAdminContext/EmployerContext/EmployeeContext). Not read from
   document.cookie: the SPA and API are on different registrable domains in
   every deployed environment, so the browser never exposes the API's
   csrftoken cookie to the SPA's own JS — it belongs to the API's domain,
   not the SPA's. AuthContext fetches this once whenever /auth/me reports
   an authenticated session (initial load, and after the Entra login
   round-trip); call refetchCsrfToken() again after anything that rotates
   the session (e.g. re-authenticating) since Django's cycle_key() on login
   invalidates the previous token. */
let csrfToken = null;

export function getCsrfToken() {
  return csrfToken;
}

export function clearCsrfToken() {
  csrfToken = null;
}

export async function refetchCsrfToken() {
  try {
    const res = await fetch(CSRF_URL, { credentials: 'include' });
    if (!res.ok) {
      csrfToken = null;
      return null;
    }
    const data = await res.json().catch(() => null);
    csrfToken = (data && data.csrftoken) || null;
    return csrfToken;
  } catch (err) {
    csrfToken = null;
    return null;
  }
}
